import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "@/app/App";

import "./index.css";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("No se encontró el elemento #root para montar la app.");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
